var mp = mp || {};


// Floor Selector
//__--------------------------------------------------------------
mp.floorSelector = function() {
    var $trigger = $('.floors__nav_item');

    if (!$trigger.length) {
        return;
    }

    if (window.location.hash) {
        $tabID = window.location.hash;
        $tabID = $tabID.replace("#tab_", "");

        if ($tabID > 0 && $tabID < 6) {
            $trigger.removeClass('active');
            $('.floors__nav [data-id="'+$tabID+'"]').addClass('active');;
        }
    }

    var $dataId = $('.floors__nav_item.active').data('id');
    getFloorData($dataId);
    
    $trigger.on('click', function(e){
        e.preventDefault();

        $trigger.removeClass('active');
        $(this).addClass('active');
        $('.floors__canvas').addClass('loading');

        var $dataId= $(this).data('id');
        getFloorData($dataId);

        window.location.hash = "tab_"+$dataId;
    })
};





function getFloorData($id) {
    $.ajax({
        method: "POST",
        url: "/get-floor-data",
        data: { id: $id }
    }).done(function(response) {
        $('.floors__canvas').html(response);
        drawFloorMap();
    });
}

function drawFloorMap(){
    $element = $('.floors__map .overlay');

    var $map = $element.find('svg');
    var $width = $map.width();
    var $height = $map.height();
    var $html = $element.html();

    $element.html('');

    var $draw = SVG(''+$element.attr('id'));
    var $svg = $draw.svg($html).size($width, $height);

    var $element = $draw.select('[data-item]');

    var $items = new Array();
    $element.members.forEach(function(item) {
        $node = item.node;

        $dataItem = $node.getAttribute("data-item");

        if ($('.floors__tooltips').find('[data-item="'+$dataItem+'"]').hasClass('sold')) {
            $node.classList.add("sold");
        };

        if ($('.floors__tooltips').find('[data-item="'+$dataItem+'"]').hasClass('reserved')) {
            $node.classList.add("reserved");
        };
    });
    
    setTimeout(function(){ 
        $('.floors__canvas').removeClass('loading');
    }, 200);

    $element.click(function(e){
        e.preventDefault();

        var $dataItem = this.data('item').toLowerCase();
        
        if (this.hasClass('no-link')) {
            return;
        } else {
            window.location.href = "/ponuda/"+$dataItem;
        }
    });

    $('.floors__tooltips .item').click(function(e){
        e.preventDefault();

        var $dataItem = $(this).data('item').toLowerCase();
        
        if ($(this).hasClass('no-link')) {
            return;
        } else {
            window.location.href = "/ponuda/"+$dataItem;
        }
    });


    $element.mouseover(function(){
        var $dataItem = this.data('item');
        var $domRect = this.rbox($draw);

        this.addClass('hover');

        $('.floors__tooltips').find('[data-item]').removeClass("show");

        $item = $('.floors__tooltips').find('[data-item="'+$dataItem+'"]');
        
        var _vpw = $(window).width();

        $translateX = $domRect.cx - ($domRect.w/2);
        $translateY = $domRect.cy + ($domRect.h/3);

        $item.css({"transform": "translate3d("+$translateX+"px, "+$translateY+"px, 0px)"}).addClass("show");

    }).mouseout(function(){
        this.removeClass('hover');
        $('.floors__tooltips').find('[data-item]').removeClass("show");
    });
}



$(document).ready(function (){
    mp.floorSelector();
});